/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { SupplyScheduleFake } from "./SupplyScheduleFake";

export class SupplyScheduleFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<SupplyScheduleFake> {
    return super.deploy(overrides || {}) as Promise<SupplyScheduleFake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SupplyScheduleFake {
    return super.attach(address) as SupplyScheduleFake;
  }
  connect(signer: Signer): SupplyScheduleFakeFactory {
    return super.connect(signer) as SupplyScheduleFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SupplyScheduleFake {
    return new Contract(address, _abi, signerOrProvider) as SupplyScheduleFake;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decayRate",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inflationRate",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IMinter",
        name: "_minter",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inflationRate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_decayRate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_mintDuration",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isMintable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintableSupply",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_number",
        type: "uint256",
      },
    ],
    name: "mock_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "mock_setBlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextMintTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "recordMintEvent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_decayRate",
        type: "tuple",
      },
    ],
    name: "setDecayRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "supplyDecayEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
